import React, {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useImperativeHandle,
} from "react";
import { ethers } from "ethers";
import { AppContext } from "../../AppContext";
import { weth, providerUrl, providerUrldprc } from "../../config";
import VaultPriceFeed from "../../contracts/VaultPriceFeed.json";

const WethBalanceFetcher = forwardRef(({ onWethBalance }, ref) => {
  const { fastestWebSocket, contractAddress } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const provider = new ethers.providers.JsonRpcProvider(providerUrl);
  const ERC20ABI = ["function balanceOf(address owner) view returns (uint256)"];

  const fetchWethPrice = async () => {
    try {
      const routerContract = new ethers.Contract(
        VaultPriceFeed.address,
        VaultPriceFeed.abi,
        provider
      );
      const acceptablePrice = await routerContract.getPriceV1(weth, false, true);
      const scaleFactor = ethers.BigNumber.from("10").pow(27);
      const priceInWei = ethers.BigNumber.from(acceptablePrice);
      return priceInWei.div(scaleFactor).toNumber() / 1000;
    } catch (error) {
      console.error("Error fetching BTC.b price:", error);
      setError(error);
      return null;
    }
  };

  const fetchWethBalance = async () => {
    setIsLoading(true);
    try {
      const wsProvider = new ethers.providers.WebSocketProvider(fastestWebSocket);
      const wethContract = new ethers.Contract(weth, ERC20ABI, wsProvider);
      const wethRawBalance = await wethContract.balanceOf(contractAddress);
      const wethBalance = parseFloat(ethers.utils.formatUnits(wethRawBalance, 18));

      const price = await fetchWethPrice();
      const usdValue = wethBalance * price;

      // Pass ONLY the USD value to the parent
      onWethBalance(usdValue.toFixed(2));
    } catch (error) {
      console.error("Error fetching WETH balance or price:", error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    reloadBalance: fetchWethBalance,
  }));

  useEffect(() => {
    fetchWethBalance();
  }, [contractAddress]);

  return null;
});

export default WethBalanceFetcher;
